import { useEffect, useState } from 'react';
import { Modal } from '../../../../theme/Component/Modal';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _BudgetID } from '../../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';
import { BasicTable } from '../../../../theme/Component/BasicTable';
import { _Product } from '../../../../../core/services/dataBean/EntityCatalogVdos';
import { SelectTaxSchemeContext } from '../../../../admin/ConfImpuestos/TaxSchemeCode/SelectTaxSchemeContext';


interface Props {
    onChange: Function;
    label?: string
}
export const SelectTaxSchemeCatalogWithAddedValue = ({ label, onChange }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_Product)

    const [modal, setModal] = useState<any>({ name: 'Tipos de Impuestos', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [valor, setValor] = useState('');

    const [idSchemeContex, setIDSchemeContex] = useState<any>();

    const head = [
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
    ]

    useEffect(() => {
        if (idSchemeContex) {
            getListas();
        }
    }, [idSchemeContex])

    const getListas = () => {
        instance.getTaxSchemeCatalogWithAddedValue(idSchemeContex, null, null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(err => { console.log(err) })
    }

    const returnValue = () => {
        if (bean.IDTaxScheme) {
            onChange(bean);
            setValor(`${bean.Code} - ${bean.Name}`)
            setModal({ ...modal, "view": false })
        } else {
            toast.error("Tipo de Impuesto no Valido")
        }
    }

    return (
        <>
            <label>{label ?? "Tipo de Impuesto"}</label>
            <div className="form-control text-wrap" style={{ minHeight: '35px' }} onClick={() => setModal({ ...modal, "view": true })}>
                {valor ?
                    valor
                    :
                    <span>Seleccionar...</span>
                }
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={() => { returnValue() }}>
                <div className="row">
                    <div className="col-md-12">
                        <SelectTaxSchemeContext idSelector={idSchemeContex} onChange={setIDSchemeContex} label='Tipo de Esquema de Impuesto' />
                    </div>
                    <div className="col-md-12">
                        <BasicTable head={head} body={lista} rowSet={setBean} />
                    </div>
                </div>
            </Modal>

        </>
    )
}